export default __webpack_public_path__ + "static/media/categories.da38d7c9.webp";